import { connect } from 'react-redux';
import { authenticateFn, signOut } from '../Authentication/authentication';
import LoginForm from '../components/access/loginForm';
const debug = process.env.REACT_APP_DEBUG && false;
const mapStateToProps = (state, ownProps) => {
    debug && console.log('Login own props', ownProps);
    return Object.assign({}, state.AccessReducer);
};
const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        authenticate: (credentials) => {
            debug && console.log('Login Container requested auth', ownProps);
            dispatch(authenticateFn(credentials));
        },
        logout: () => dispatch(signOut()),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(LoginForm);
